
export type Locale = "vi" | "en";

export const translations = {
  vi: {
    // Common
    appTitle: "Vipex Excel Agent",
    chat: "Trò chuyện",
    files: "Tệp tin",
    settings: "Cài đặt",
    debug: "Gỡ lỗi",
    newChat: "Đoạn chat mới",
    untitledChat: "Đoạn chat chưa đặt tên",
    switchSession: "Chuyển phiên",
    noHistory: "Chưa có lịch sử",
    deleteChat: "Xóa đoạn chat",
    signOut: "Đăng xuất",
    stop: "Dừng",
    send: "Gửi",
    refresh: "Làm mới",
    key: "Khóa",
    value: "Giá trị",

    // Chat
    emptyStateMessage: "Hãy hỏi bất cứ điều gì về trang tính của bạn.",
    inputPlaceholder: "Nhập tin nhắn...",
    uploading: "Đang tải lên...",
    processingFile: "Đang xử lý tệp, vui lòng đợi...",
    noDocuments: "Chưa có tài liệu đính kèm",
    sessionFiles: "Tệp tin trong phiên",
    attachmentsDescription: "Đính kèm và tài liệu trong phiên trò chuyện này",

    // Settings
    userPreferences: "Tùy chọn người dùng",
    language: "Ngôn ngữ",
    theme: "Giao diện",
    lightMode: "Sáng",
    darkMode: "Tối",
    systemTheme: "Hệ thống",
    serverConfig: "Cấu hình máy chủ",
    serverConfigDescription: "Nhà cung cấp API, mô hình và khóa được đọc từ .env trên máy chủ. Khởi động lại backend sau khi chỉnh sửa env.",
    llmProvider: "Nhà cung cấp LLM",
    llmModel: "Mô hình LLM",
    visionProvider: "Nhà cung cấp Vision",
    visionModel: "Mô hình Vision",
    backendUnreachable: "Không thể kết nối máy chủ",
    backendUnreachableDescription: "Không thể tải cấu hình từ máy chủ. Vui lòng đảm bảo dịch vụ đang chạy.",

    // Login
    signInToContinue: "Đăng nhập để tiếp tục",
    createAccount: "Tạo tài khoản",
    username: "Tên đăng nhập",
    password: "Mật khẩu",
    confirmPassword: "Xác nhận mật khẩu",
    signIn: "Đăng nhập",
    register: "Đăng ký",
    creating: "Đang tạo...",
    signingIn: "Đang đăng nhập...",
    passwordsDoNotMatch: "Mật khẩu không khớp",
    usernamePasswordRequired: "Cần có tên đăng nhập và mật khẩu",
    dontHaveAccount: "Chưa có tài khoản?",
    alreadyHaveAccount: "Đã có tài khoản?",
    invalidCredentials: "Thông tin đăng nhập không hợp lệ",
    usernameAlreadyTaken: "Tên đăng nhập đã được sử dụng",

    // Tool Confirmation
    confirmationRequired: "Yêu cầu xác nhận",
    confirmationDescription: "Tác vụ muốn thực hiện thay đổi trên workbook. Bạn có cho phép thực hiện không?",
    allowAction: "Cho phép",
    reject: "Từ chối",

    // Technical
    analysisStep: "Bước phân tích",
    systemConfiguration: "Cấu hình hệ thống",
    reasoning: "Lập luận",
    arguments: "Tham số",
    result: "Kết quả",
    error: "Lỗi",
    awaitingApproval: "Đang chờ bạn phê duyệt...",
    awaitingSelection: "Đang chờ lựa chọn của bạn...",
    connectedWorkbooks: "Các Workbook đã kết nối",
    activeNow: "Đang hoạt động",
    connected: "Đã kết nối",
    showAdvancedStats: "Hiển thị thống kê nâng cao",
    somethingWentWrong: "Đã có lỗi xảy ra",
    detailsHidden: "Chi tiết được ẩn vì lý do bảo mật",
    toolNames: {
      get_range_as_json: "Lấy dữ liệu vùng",
      modify_sheet_structure: "Chỉnh sửa cấu trúc trang tính",
      summarize_workbook: "Tóm tắt sổ tính",
      analyze_sheet_structure: "Phân tích cấu trúc trang tính",
      write_cells: "Ghi dữ liệu ô",
      set_cell_range: "Thiết lập vùng ô",
      search_data: "Tìm kiếm dữ liệu",
      evaluate_formula: "Tính toán công thức",
      python_exec: "Chạy mã Python",
      bash: "Lệnh hệ thống",
      read: "Đọc tệp tin",
      eval_officejs: "Lệnh Office.js",
      get_range_as_csv: "Đọc dữ liệu CSV",
      clear_cell_range: "Xóa vùng ô",
      copy_to: "Sao chép đến",
      insert_batch: "Chèn dữ liệu hàng loạt",
      ask_user: "Yêu cầu lựa chọn",
    },

    // Skills
    skills: "Kỹ năng",
    skillsPickerTitle: "Chọn kỹ năng",
    skillsPickerHint: "Áp dụng cho tin nhắn kế tiếp",
    skillsPickerSearchPlaceholder: "Tìm kỹ năng...",
    skillsPickerEmpty: "Không có kỹ năng phù hợp",
    skillsActiveBadge: "1 lần",
    skillsRemove: "Bỏ kỹ năng",

    // Voice
    voiceListening: "Đang nghe...",
    voiceNotSupported: "Trình duyệt không hỗ trợ nhận giọng nói",
    voicePermissionDenied: "Không có quyền truy cập microphone",
    voiceNetworkError: "Lỗi mạng khi nhận giọng nói",
    voiceMicError: "Không thể truy cập microphone",
    voiceGenericError: "Đã xảy ra lỗi khi nhận giọng nói",
  },
  en: {
    // Common
    appTitle: "Vipex Excel Agent",
    chat: "Chat",
    files: "Files",
    settings: "Settings",
    debug: "Debug",
    newChat: "New Chat",
    untitledChat: "Untitled Chat",
    switchSession: "Switch Session",
    noHistory: "No history yet",
    deleteChat: "Delete Chat",
    signOut: "Sign Out",
    stop: "Stop",
    send: "Send",
    refresh: "Refresh",
    key: "Key",
    value: "Value",

    // Chat
    emptyStateMessage: "Ask anything about your spreadsheet.",
    inputPlaceholder: "Type a message...",
    uploading: "Uploading...",
    processingFile: "Processing file, please wait...",
    noDocuments: "No documents attached yet",
    sessionFiles: "Session Files",
    attachmentsDescription: "Attachments and documents in this chat session",

    // Settings
    userPreferences: "User Preferences",
    language: "Language",
    theme: "Theme",
    lightMode: "Light",
    darkMode: "Dark",
    systemTheme: "System",
    serverConfig: "Server Configuration",
    serverConfigDescription: "API provider, model, and keys are read from .env on the server. Restart the backend after editing env.",
    llmProvider: "LLM Provider",
    llmModel: "LLM Model",
    visionProvider: "Vision Provider",
    visionModel: "Vision Model",
    backendUnreachable: "Backend Unreachable",
    backendUnreachableDescription: "Could not load configuration from server. Ensure the service is running.",

    // Login
    signInToContinue: "Sign in to continue",
    createAccount: "Create an account",
    username: "Username",
    password: "Password",
    confirmPassword: "Confirm Password",
    signIn: "Sign In",
    register: "Register",
    creating: "Creating...",
    signingIn: "Signing in...",
    passwordsDoNotMatch: "Passwords do not match",
    usernamePasswordRequired: "Username and password are required",
    dontHaveAccount: "Don't have an account?",
    alreadyHaveAccount: "Already have an account?",
    invalidCredentials: "Invalid credentials",
    usernameAlreadyTaken: "Username already taken",

    // Tool Confirmation
    confirmationRequired: "Confirmation Required",
    confirmationDescription: "The agent wants to perform a workbook modification. Do you want to allow this action?",
    allowAction: "Allow Action",
    reject: "Reject",

    // Technical
    analysisStep: "Analysis step",
    systemConfiguration: "System configuration",
    reasoning: "Reasoning",
    arguments: "Arguments",
    result: "Result",
    error: "Error",
    awaitingApproval: "Awaiting your approval...",
    awaitingSelection: "Waiting for your choice...",
    connectedWorkbooks: "Connected Workbooks",
    activeNow: "Active now",
    connected: "Connected",
    showAdvancedStats: "Show advanced stats",
    somethingWentWrong: "Something went wrong",
    detailsHidden: "Details hidden for security reasons",
    toolNames: {
      get_range_as_json: "Get Range as JSON",
      modify_sheet_structure: "Modify Sheet Structure",
      summarize_workbook: "Summarize Workbook",
      analyze_sheet_structure: "Analyze Sheet Structure",
      write_cells: "Write Cells",
      set_cell_range: "Set Cell Range",
      search_data: "Search Data",
      evaluate_formula: "Evaluate Formula",
      python_exec: "Python Execution",
      bash: "Bash Command",
      read: "Read File",
      eval_officejs: "Office.js Execution",
      get_range_as_csv: "Get Range as CSV",
      clear_cell_range: "Clear Cell Range",
      copy_to: "Copy To",
      insert_batch: "Insert Batch",
      ask_user: "Option Prompt",
    },

    // Skills
    skills: "Skills",
    skillsPickerTitle: "Choose a skill",
    skillsPickerHint: "Applies to your next message",
    skillsPickerSearchPlaceholder: "Search skills...",
    skillsPickerEmpty: "No matching skills",
    skillsActiveBadge: "one-shot",
    skillsRemove: "Remove skill",

    // Voice
    voiceListening: "Listening...",
    voiceNotSupported: "Voice recognition not supported in this browser",
    voicePermissionDenied: "Microphone permission denied",
    voiceNetworkError: "Network error during voice recognition",
    voiceMicError: "Cannot access microphone",
    voiceGenericError: "Voice recognition error",
  }
};

class I18nManager {
  locale = $state<Locale>((localStorage.getItem("excel-agent-lang") as Locale) || "vi");

  t = (key: keyof typeof translations.en) => {
    return translations[this.locale][key] || key;
  };

  setLocale(l: Locale) {
    this.locale = l;
    localStorage.setItem("excel-agent-lang", l);
  }
}

export const i18n = new I18nManager();
